import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PROXYVOTE_JOB_BASE_PATH } from '../../../../../../../../../features/proxyvote/job/proxyvote-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-job/_job')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'beta-nxt-proxy-vote-job-list',
        label: 'BetaNXT',
        to: PROXYVOTE_JOB_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
